import type { FieldValidation } from '@rjsf/utils';

const REPO_NAME_PATTERN =
  /^(app|service|lib|tool|infra|docs|data|poc)-[a-z][a-z0-9]*(-[a-z0-9]+)+(-anz|-na|-emea|-asia)?$/;

export function gitHubRepoPickerValidation(
  value: string,
  validation: FieldValidation,
  context: { uiSchema?: Record<string, unknown> },
) {
  if (!value) {
    validation.addError('Repository URL is required');
    return;
  }

  try {
    const parsed = new URL(`https://${value}`);
    const host = parsed.host;
    const owner = parsed.searchParams.get('owner');
    const repo = parsed.searchParams.get('repo');

    if (!host) {
      validation.addError('Host is required');
    }
    if (!owner) {
      validation.addError('Owner is required');
    }
    if (!repo) {
      validation.addError('Repository name is required');
    }

    const mode =
      (context.uiSchema?.['ui:options'] as Record<string, unknown>)?.mode ??
      'new';

    if (mode === 'new' && repo && !REPO_NAME_PATTERN.test(repo)) {
      validation.addError(
        'Repository name must follow the pattern: type-productarea-name (e.g. service-payments-api)',
      );
    }
  } catch {
    validation.addError('Invalid repository URL format');
  }
}
